import React, {Component} from 'react';
import Helmet from 'react-helmet';

const initialState = {
}

class Error extends Component {
  state=initialState

  // 初期処理
  componentDidMount() {

  }

  // 画面表示処理
  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));
    
    // URLのERROR_MESSAGEパラメータに「CO-AT3100」を含む場合
    if (this.props.params && this.props.params.ERROR_MESSAGE && this.props.params.ERROR_MESSAGE.indexOf('CO-AT3100') !== -1){
      return (
        <section>

          <Helmet
            title={messageList.error.M001_title}>
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="hdg-l1">
            <h1 className="hdg-l1_txt">{messageList.error.M001_title}</h1>
          </div>

          {/* エラーメッセージ */} 
          <div className="panel-attention">
            <h2 className="panel-attention_hdg">
              <span className="panel-attention_icon">
                <img src={`${process.env.PUBLIC_URL}/img/icon_error.svg`} alt={messageList.error.M002_errorIconText}/>
              </span>{messageList.error.M003_errorBoxTitle}
            </h2>
            {(this.props.params.AUTH_TYPE === 'AUTH_ONETIME') 
            ?
            <p>{messageList.error.M004_errorMessage4}</p>
            :
            <p>{messageList.error.M004_errorMessage1}</p>
            }
          </div>

          {/* 操作ボタン表示部 */}
          <div className="btn-wrap">
            <a href="https://www.jal.com/index.html" className="btn-back">{messageList.error.M005_home}</a>
          </div>
        </section>
      )
    }
    // URLのERROR_MESSAGEパラメータに「UserIdentifiedKeyIsNotMatchException」を含む場合
    else if (this.props.params && this.props.params.ERROR_MESSAGE && this.props.params.ERROR_MESSAGE.indexOf('UserIdentifiedKeyIsNotMatchException') !== -1){
      return (
        <section>

          <Helmet
            title={messageList.error.M001_title}>
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="hdg-l1">
            <h1 className="hdg-l1_txt">{messageList.error.M001_title}</h1>
          </div>

          {/* エラーメッセージ */} 
          <div className="panel-attention">
            <h2 className="panel-attention_hdg">
              <span className="panel-attention_icon">
                <img src={`${process.env.PUBLIC_URL}/img/icon_error.svg`} alt={messageList.error.M002_errorIconText}/>
              </span>{messageList.error.M003_errorBoxTitle}
            </h2>
            <p>{messageList.error.M004_errorMessage2}</p>
          </div>

          {/* 操作ボタン表示部 */}
          <div className="btn-wrap">
            <a href="https://www.jal.com/index.html" className="btn-back">{messageList.error.M005_home}</a>
          </div>
        </section>
      )
    }
    // URLのERROR_MESSAGEパラメータに「RecordNotFoundException」を含む場合
    else if (this.props.params && this.props.params.ERROR_MESSAGE && this.props.params.ERROR_MESSAGE.indexOf('RecordNotFoundException') !== -1){
      return (
        <section>

          <Helmet
            title={messageList.error.M001_title}>
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="hdg-l1">
            <h1 className="hdg-l1_txt">{messageList.error.M001_title}</h1>
          </div>

          {/* エラーメッセージ */} 
          <div className="panel-attention">
            <h2 className="panel-attention_hdg">
              <span className="panel-attention_icon">
                <img src={`${process.env.PUBLIC_URL}/img/icon_error.svg`} alt={messageList.error.M002_errorIconText}/>
              </span>{messageList.error.M003_errorBoxTitle}
            </h2>
            <p>{messageList.error.M004_errorMessage3}</p>
          </div>

          {/* 操作ボタン表示部 */}
          <div className="btn-wrap">
            <a href="https://www.jal.com/index.html" className="btn-back">{messageList.error.M005_home}</a>
          </div>
        </section>
      )
    }
    // 「通知先が登録されない」エラー画面（OTP入力画面から遷移）
    else if (this.props.location.state && 
        (this.props.location.state.errorScreen === 'ADDRESS_UNREGISTERED_OTPLOGIN')){
        return (
          <section>

            <Helmet
              title={messageList.error.browserTitle}>
            </Helmet>

            {/* 画面タイトル表示部 */}
            <div className="hdg-l1">
              <h1 className="hdg-l1_txt">以下をご確認ください/<span lang="en">Please review the below</span></h1>
            </div>

            {/* 画面項目表示部 */}
            <div className="box-txt">
              <p>{messageList.error.guideMessage005}</p>
              <a href="https://www.jal.co.jp/jalonline/contact/" className="link-txt sp-disnon">{messageList.error.link001}</a>
              <a href="https://www.jal.co.jp/jalonline/contact/" className="link-txt pc-disnon">{messageList.error.link002}</a>
            </div>

            <div className="box-txt">
              <p lang="en">{messageList.error.guideMessage007}<br></br>
              {messageList.error.guideMessage008}</p>
              <a href="https://www.jal.co.jp/jalonline/contact/" className="link-txt" lang="en">{messageList.error.link003}</a>
            </div>

            {/* 操作ボタン表示部 */}
            <div className="btn-wrap">
              <a href="https://www.jal.com/index.html" className="btn-back">{messageList.error.button001}<span lang="en">{messageList.error.button002}</span></a>
            </div>
          </section>
        )
    }
    // 「戻るボタン押下」エラー画面
    else if (this.props.location.state && 
      (this.props.location.state.errorScreen === 'BACKWARD_BUTTON_CLICKED')){
      return (
        <section>

          <Helmet
            title={messageList.error.browserTitle}>
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="hdg-l1">
            <h1 className="hdg-l1_txt">{messageList.error.pageTitle001}<span lang="en">{messageList.error.pageTitle002}</span></h1>
          </div>

          {/* 画面項目表示部 */}
          <div className="box-txt">
            <p>ブラウザの戻るボタンは使用出来ません。<br></br>
            お使いのブラウザを閉じてから再度お試しください。</p>
            <p lang="en">Please do not use your browser's Back button.<br></br>
            You will need to close and restart your browser.</p>
          </div>

          {/* 操作ボタン表示部 */}
          <div className="btn-wrap">
            <a href="https://www.jal.com/index.html" className="btn-back">{messageList.error.button001}<span lang="en">{messageList.error.button002}</span></a>
          </div>
        </section>
      )
    }
    // パスワード管理画面遷移時に、ID/PWD未認証の場合
    else if (this.props.location.state && 
      (this.props.location.state.errorScreen === 'UNAUTHORIZATED_PWD_CHANGE')){
      return (
        <section>

          <Helmet
            title={messageList.error.M001_title}>
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="hdg-l1">
            <h1 className="hdg-l1_txt">{messageList.error.M001_title}</h1>
          </div>

          {/* エラーメッセージ */} 
          <div className="panel-attention">
            <h2 className="panel-attention_hdg">
              <span className="panel-attention_icon">
                <img src={`${process.env.PUBLIC_URL}/img/icon_error.svg`} alt={messageList.error.M002_errorIconText}/>
              </span>{messageList.error.M003_errorBoxTitle}
            </h2>
            <p>{messageList.error.guideMessage009}<br></br>
            <a href="https://booking.jal.co.jp/jl/corp-john/login/member-login-manager-before-process" className="link-txt sp-disnon">{messageList.error.link004}</a>
            <a href="https://booking.jal.co.jp/jl/corp-john/login/member-login-manager-before-process" className="link-txt pc-disnon">{messageList.error.link004}</a>
            </p>
          </div>


          {/* 操作ボタン表示部 */}
          <div className="btn-wrap">
            <a href="https://www.jal.com/index.html" className="btn-back">{messageList.error.M005_home}</a>
          </div>
        </section>
      )
    }
    // ユーザIDがゲスト用共通IDで、OTP入力画面へ遷移する場合
    else if (this.props.location.state && 
      (this.props.location.state.errorScreen === 'INVALID_USER_TRANSITION_OTPLOGIN')){
      return (
        <section>

          <Helmet
            title={messageList.error.browserTitle}>
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="hdg-l1">
            <h1 className="hdg-l1_txt">以下をご確認ください/<span lang="en">Please review the below</span></h1>
          </div>

          {/* 画面項目表示部 */}
          <div className="box-txt">
            <p>{messageList.error.guideMessage010}</p>
          </div>

          <div className="box-txt">
            <p lang="en">{messageList.error.guideMessage011}</p>
          </div>

          {/* 操作ボタン表示部 */}
          <div className="btn-wrap">
            <a href="https://www.jal.com/index.html" className="btn-back">{messageList.error.button001}<span lang="en">{messageList.error.button002}</span></a>
          </div>
        </section>
      )
  	}
  	// 通常のエラー画面
    else {
      return (
        <section>

          <Helmet
            title={messageList.error.browserTitle}>
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="hdg-l1">
            <h1 className="hdg-l1_txt">{messageList.error.pageTitle001}<span lang="en">{messageList.error.pageTitle002}</span></h1>
          </div>

          {/* 画面項目表示部 */}
          <div className="box-txt">
            <p>{messageList.error.guideMessage001}<br></br>
            {messageList.error.guideMessage002}</p>
            <p lang="en">{messageList.error.guideMessage003}<br></br>
            {messageList.error.guideMessage004}</p>
          </div>

          {/* 操作ボタン表示部 */}
          <div className="btn-wrap">
            <a href="https://www.jal.com/index.html" className="btn-back">{messageList.error.button001}<span lang="en">{messageList.error.button002}</span></a>
          </div>
        </section>
      )
    }
  }
}

export default Error